import { render, staticRenderFns } from "./ModalRejectRequest.vue?vue&type=template&id=081a3ff4&"
import script from "./ModalRejectRequest.vue?vue&type=script&lang=js&"
export * from "./ModalRejectRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports